import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Big3Common, bootstrap } from '../../../js/IncludeManager'
import { Confirm } from "../../../js/ComponentManager";
/* 개발담당:양유빈
 * 화면기능:플랫폼 메인 페이지
 * 세부설명:
*/

export class MypageSub extends Component {
    static displayName = MypageSub.name;

    constructor(props) {
        super(props);
        this.state = {
            RoleList: [],
            Goods_Count: 0,
            Retail_Count: 0,
        };
        this.handleLogOut_Click = this.handleLogOut_Click.bind(this);
    }
    //초기화
    componentDidMount() {
        this.RoleCodeDataCall();
        this.CallGoodsRetailCount();
    }
    CallGoodsRetailCount = async () => {
        try {

            let Data = await Big3Common.Get("api/MyPage/MyInfoMgr/GetGoodsRetailCount");
            if (Data.codeName === Big3Common.ResultCode.Success) {
                const DataList = JSON.parse(Data.multiDataTable);
                const Info = DataList.GoodsList;
                if (Info.length > 0) {
                    this.setState({
                        Goods_Count: Info[0].goods_count,
                        Retail_Count: Info[0].retail_count
                    })
                }
            }

        }
        catch (e) {
            console.log("handleLogOut_Click: ", e)
        }
        return false;
    }
    async RoleCodeDataCall() {
        try {
            //권한관리 코드 018
            const MstCd = "018";
            let Data = await Big3Common.Get(`api/Common/BaseCode/GetCommonCode/${MstCd}`);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                let MyData = await Big3Common.Get(`api/MyPage/Employee/GetSubmemberRoleList`);

                let MyRoleList = JSON.parse(MyData.dataTable);
                let RoleList = JSON.parse(Data.dataTable);
                
                let MyRoleFilter = [];
                RoleList.filter(rst => {
                    MyRoleList.filter(mst => {
                        if (rst.dtl_cd === mst.role_cd) {
                            MyRoleFilter.push({
                                Role_cd: rst.dtl_cd,
                                Role_Nm: rst.dtl_nm
                            })
                        }
                        return false;
                    });
                    return false;
                });
                if (RoleList.length > 0) {
                    this.setState({ RoleList: MyRoleFilter })
                }
            }
            else {
                console.log("등록된 코드가 없습니다.");
            }
        }
        catch (e) {
            console.log("RoleCodeDataCall: ", e)
        }
        return false;
    }
    async handleLogOut_Click() {
        try {

            let Data = await Big3Common.Get("api/Common/Common/Logout");
            if (Data.codeName === Big3Common.ResultCode.Success) {
                Big3Common.Util.RemoveLoginStorage();
                Big3Common.Util.OpenWindowLink("/Account/LoginMgr/Index");
            }
            else {
                alert(Data.message);
            }
        }
        catch (e) {
            console.log("handleLogOut_Click: ", e)
        }
        return false;
    }
    GetLinkUrl(Dtl_Cd) {
        if (Dtl_Cd === "OR") {
            //주문관리
            return "/Order/OrderMgr/Index";
        }
        else if (Dtl_Cd === "GO") {
            //상품관리
            return "/Goods/GoodsMgr/Index";
        }
        else if (Dtl_Cd === "PA") {
            //거래처관리
            return "/Retail/MyRetail/Index";
        }
        else if (Dtl_Cd === "ST") {
            //매장관리
            return "StoreMsg";
        }
        else if (Dtl_Cd === "SE") {
            //정산관리
            return "CostSettleList";
        }
        else {
            return "";
        }
    }
    render() {
        const RoleList = this.state.RoleList;
        return (
            <div className="container_box p_f_margin u_padding ">
                <div className="mypage_info">
                    <div className="shop_name">{Big3Common.WebStorage.GetLocalStorage(Big3Common.WebStorage.StorageName.OrgName)}</div>
                    <div className="login_name">{Big3Common.WebStorage.GetLocalStorage(Big3Common.WebStorage.StorageName.UserName)}님 반갑습니다!!</div>
                    <div className="shop_retail">내 거래매장 : {this.state.Retail_Count}매장</div>
                    <div className="shop_retail">판매중인 상품 : {this.state.Goods_Count}개</div>
                </div>
                {
                    RoleList.map((list, idx) => {
                        //주문관리, 상품관리
                        if (list.Role_cd === "OR" || list.Role_cd === "GO" || list.Role_cd === "PA") {
                            return (
                                <div className="mypage_info mypage_info_employee" key={list.key + "_" + idx}>
                                    <Link to={this.GetLinkUrl(list.Role_cd)} >
                                        <div className="my_page_menu_title">{list.Role_Nm}</div>
                                    </Link>
                                </div>
                            )
                        }
                        else if (list.Role_cd === "ST") {
                            //매장관리
                            return (
                                <div className="mypage_info mypage_info_employee" key={list.key + "_" + idx}>
                                    <div className="my_page_menu_title">{list.Role_Nm}</div>
                                    <div className="my_page_menu" onClick={(e) => this.props.RenderComponent('StoreInfo')}>매장 정보수정</div>
                                    <div className="my_page_menu" onClick={(e) => this.props.RenderComponent('StoreMsg')}>매장 공지사항</div>
                                    <div className="my_page_menu" onClick={(e) => this.props.RenderComponent('AccountNumber')}>계좌정보 관리</div>
                                </div>
                            )
                        }
                        else if (list.Role_cd === "SE") {
                            return (
                                <div className="mypage_info mypage_info_employee" key={list.key + "_" + idx}>
                                    <div className="my_page_menu_title" onClick={(e) => this.props.RenderComponent(this.GetLinkUrl(list.Role_cd))}>{list.Role_Nm}</div>
                                </div>
                            )
                        }
                        else {
                            return (
                                ""
                            )
                        }
                    }    
                )}
                               

                <div className="mypage_info bn">
                    <div className="my_page_menu_title pointer" onClick={() => {
                        Big3Common.ModalAlert(bootstrap, 'ConfirmBox');
                    }}>로그아웃</div>
                </div>
                <Confirm
                    id="ConfirmBox"
                    title="로그아웃 하시겠습니까?"
                    ConfirmClick={() => {
                        setTimeout(() => {
                            Big3Common.ModalClose(bootstrap, 'ConfirmBox');
                        }, 500);
                        this.handleLogOut_Click()
                    }}
                />
            </div>
        );
    }
}
